/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import onClickOutside from 'react-onclickoutside'

/**
 *     Import
 *     - Libraries
 */
import './styles/Company.css'

/**
 *     Import
 *     - Components
 */
import CompaniesList from './Components/CompaniesList'
import { BinIcon } from '../../../images/icons/Bin/Bin'
import { SpinnerIcon } from '../../../images/icons/Spinner/Spinner'

/**
 * CompanyLookup class
 * Searches for company names taht matchs with the user's input
 *
 * @class CompanyLookup
 * @extends {React.Component<any, any>}
 */
class CompanyLookup extends React.Component<any, any> {

    /**
     * Creates an instance of CompanyLookup.
     *
     * @param {*} props
     * @memberof CompanyLookup
     */
    constructor(props: any) {
        super(props)
        this.state = {
            inputText: '',
            dropDownVisible: false,
            companyName: null,
        }
    }

    /**
     * Handle an outside click for closing the dropdown
     *
     * @memberof CompanyLookup
     */
    handleClickOutside = (evt) => {
        this.setState({ dropDownVisible: false })
    }

    /**
     * Will make the search action calling the API
     *
     * @param {*} event
     * @memberof CompanyLookup
     */
    search = (event: any) => {
        if (event.type === 'click' || (event.keyCode === 13)) {
            event.preventDefault()
            this.props.companyNameSearch(this.state.inputText)
            this.setState({ dropDownVisible: true })
        }
    }

    /**
     * Resets all the information inside the component
     *
     * @memberof CompanyLookup
     */
    resetData = () => {
        this.setState({ dropDownVisible: false, companyName: null })
        this.props.changeBusinessName('', '')
    }

    /**
     * Save a new component selected by the user
     *
     * @param {*} address
     * @memberof CompanyLookup
     */
    selectNewCompany = (address: any) => {
        this.setState({ dropDownVisible: false, companyName: address.name })
        this.props.changeBusinessName(address.id, address.name)
        this.changeInput('')
    }

    /**
     * Changes the input where the user write the company name
     *
     * @memberof CompanyLookup
     */
    changeInput = (inputText) => {
        this.setState({ inputText })
        if (this.props.isUK === false && this.props.checkCountrySelect) {
            this.props.changeBusinessName('0', inputText)
        }
    }

    render() {
        const { loading, done, response } = this.props.companyNames.companyNames

        return (
            <div>
                <div
                    className=
                    {`quote__form__group form__${(this.state.companyName) ? 'w90' : 'w100'} company company__lookup
                    change_zindex`}
                >
                    {(!this.state.companyName) ?
                        <div>
                            <label>Business name</label>
                            <input
                                name="postcode"
                                id="postcode"
                                type="text"
                                className={`form-control`}
                                placeholder="Find business name (enter name)"
                                onChange={(event) => { this.changeInput(event.target.value) }}
                                onKeyDown={(event) => { this.search(event) }}
                                autoComplete="off"
                            />
                            {(loading) ?
                                (
                                    <div className="company__icon company spinner">
                                        <div className="spinner__spin">
                                            <SpinnerIcon />
                                        </div>
                                    </div>
                                ) :
                                <div>
                                    {this.props.isUK &&
                                        <div
                                            className="company__icon company company__find pointer"
                                            onClick={this.search}
                                        >
                                            <span>FIND</span>
                                        </div>
                                    }
                                </div>
                            }
                        </div>

                        : null
                    }
                    {(!loading && done && this.state.dropDownVisible) ?
                        CompaniesList(response, this.selectNewCompany, this.resetData) :
                        null}

                    {
                        (this.state.companyName) ?
                            <div>
                                <label>Business name</label>
                                <input
                                    name="businessName"
                                    id="businessName"
                                    type="text"
                                    placeholder="Business name (legal entity)"
                                    value={this.state.companyName}
                                    readOnly={true}
                                />
                            </div>
                            : null
                    }

                </div>

                {(this.state.companyName) ?
                    <div className="quote__form__group form__w10 bin" onClick={this.resetData}>
                        <BinIcon />
                    </div> : null}
            </div>

        )
    }
}

export default onClickOutside(CompanyLookup)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Company/CompanyLookup.tsx